var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"wx_relative_dialog",attrs:{"visible":_vm.visible,"width":"92%","top":"4vh","title":"厂家直采关联","append-to-body":""},on:{"update:visible":function($event){_vm.visible=$event},"close":_vm.onClose}},[(_vm.visible)?_c('connect-box',{ref:"connectBox",on:{"close":_vm.close,"saved":_vm.onSaved}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }